import { QuoteConvertEligibility } from './getQuoteConvertEligibility'

export const isQuoteConvertibleToInvoice = (convertEligibility: QuoteConvertEligibility): boolean => {
  if (!convertEligibility.canShowConvertActions) {
    return false
  }

  return (
    convertEligibility.canConvertToRegularInvoice ||
    convertEligibility.canCreateDepositInvoice ||
    convertEligibility.isQuotePartiallyInvoiced
  )
}
